// Which rows the folder poll (App.js pollMessages) may drop because the server
// stopped returning them — deleted or moved on another device.
//
// The poll fetches only the top page, so a row missing from it is only
// evidence of a delete inside the window that page covered. Absent rows are
// kept when:
//   · the poll is filtered — "absent" may just mean "no longer matches";
//   · no fetched row has a usable date — no window to place them against;
//   · a read / flag / reply on the row is still settling (the op guards);
//   · the page came back full and the row is at or below its oldest row — it
//     is on a later Load-More page, which this poll did not fetch;
//   · the row is NEWER than every fetched row and itself only just arrived
//     (within NEW_ARRIVAL_GRACE_MS) — the server may not have it yet.
//
// That last guard used to have no time limit (July 2026): the newest email in
// a folder, deleted on a phone, was newer than everything the server still
// returned and so was kept forever — until a full reload, or until newer mail
// arrived (2026-10-19, darren@: deleted a minute after it arrived, still
// listed five minutes later although the server had already re-homed it to
// Deleted Items). New mail reaches the index within seconds, so two minutes
// is ample; past that, a row the server no longer returns is gone.
//
// Pure: no React, no fetch — App.js passes the page it already fetched.

export const NEW_ARRIVAL_GRACE_MS = 2 * 60_000;

export const msgTime = (m) => Date.parse(m?.date || m?.receivedDateTime || '');

// The window a fetched page covers.
export function pageWindow(incoming, pageSize) {
  const times = (incoming || []).map(msgTime).filter(Number.isFinite);
  return {
    haveWindow: times.length > 0,
    newest: times.length ? Math.max(...times) : null,
    oldest: times.length ? Math.min(...times) : null,
    full: (incoming || []).length >= pageSize,
  };
}

// Is this absent row a prune candidate on this poll? The caller still requires
// two consecutive misses (one on a refocus resync) before dropping it.
export function isPruneCandidate(m, { window, filterActive = false, heldOptimistic = () => false, now = Date.now() }) {
  if (filterActive) return false;
  if (!window || !window.haveWindow) return false;
  if (heldOptimistic(m.id)) return false;
  const ts = msgTime(m);
  if (!Number.isFinite(ts)) return false;
  if (ts > window.newest && now - ts < NEW_ARRIVAL_GRACE_MS) return false;
  if (window.full && ts <= window.oldest) return false;
  return true;
}
